import { useMemo } from "react";

// Artwork drifting slowly in and out of the background — apparitions on paper.
// Items are stride-sampled across the WHOLE catalogue, and each one quietly
// swaps to the next artwork at the invisible end of every drift cycle, so the
// background keeps rotating through everything on its own.
const DriftingField = ({ images, count = 9, opacity = 0.09, size = 220 }) => {
  const items = useMemo(
    () =>
      Array.from({ length: Math.min(count, images.length) }, (_, i) => ({
        start: Math.floor((i * images.length) / Math.min(count, images.length)),
        left: (i * 37 + 11) % 88,
        top: (i * 53 + 7) % 84,
        w: size + ((i * 61) % 120) - 60,
        tilt: ((i * 29) % 9) - 4,
        dur: 22 + ((i * 13) % 14),
        delay: -((i * 3.7) % 26),
      })),
    [images, count, size]
  );

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      {items.map((it, i) => (
        <img
          key={i}
          src={images[it.start]}
          alt=""
          className="drift-item"
          data-cycle="0"
          onAnimationIteration={(e) => {
            // swap to the next artwork while invisible at the cycle's edge
            const next = (Number(e.currentTarget.dataset.cycle) + 1) % Math.ceil(images.length / items.length);
            e.currentTarget.dataset.cycle = String(next);
            e.currentTarget.src = images[(it.start + next * items.length) % images.length];
          }}
          style={{
            left: `${it.left}%`,
            top: `${it.top}%`,
            width: `${it.w}px`,
            "--drift-o": opacity,
            "--drift-dur": `${it.dur}s`,
            "--drift-delay": `${it.delay}s`,
            "--drift-tilt": `${it.tilt}deg`,
          }}
        />
      ))}
    </div>
  );
};

export default DriftingField;
